import { BaseContext } from "src/com/sixdee/crbtportal/utils/basecontext";
import { UIComponentHandler, UIComponentImpl, UIDataModel } from "../../uicomponent";
import { UIComponentCSSStyle } from "../../uicomponentcss";
import { UIComponentView } from "../../uicomponentview";
import { TextComponentHandler, TextComponentProps, TextComponentState } from "../textcomponent";
import { TextCSSStyleImpl } from "../textcss";
import { MemberTextViewImpl } from "./membertextview";




export interface MemberTextComponentHandler extends TextComponentHandler
{
    onChange(data: string): void;
}

export class MemberTextComponent extends UIComponentImpl<TextComponentProps, TextComponentState, UIDataModel> 
       implements MemberTextComponentHandler
{
    constructor(props: TextComponentProps)
    {
        super(props);

        this.state = {value: props.value, errorMessage: undefined, class: ""};
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new MemberTextViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new TextCSSStyleImpl(applicationContext);
    }

    setErrorMessage(errorMesssage: string)
    {
        this.setState({errorMessage: errorMesssage});
    }

    UNSAFE_componentWillReceiveProps(newProps:TextComponentProps)
    {
        this.setState({value: newProps.value});
    }

    onChange(data: string): void 
    {
        this.props.onChange !== undefined && this.props.onChange(data.slice(0, +this.props.maxLength));

        if (data !== '') {
            this.setState({value: data.slice(0, +this.props.maxLength), class: "on"});
        }
        else {
                this.setState({value: data.slice(0, +this.props.maxLength), class: ""});
        }
    }

    getData(): string
    {
        return this.state.value;
    }

    clearData()
    {
        this.setState({value: "", errorMessage: undefined});
    }

    validate(): boolean
    {
        if(this.props.isRequired && this.state.value.length === 0)
        {
            this.setState({errorMessage: this.props.emptyErrorMsg});

            return false;
        }
        else
        {
            this.setState({errorMessage: undefined});

            return true;
        }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/text/membertext/membertextcomponent.tsx